export default class Text {
    public text_id: string | null = null;
    public code: string | null = null;
    public text: string | null = null;
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Text>) {
        Object.assign(this, data);
    }
}
